export const createMinMaxSlice = (set) => ({
    dataStreamMaxes: {},
    dataStreamMins: {},
    setMaxes: (datastreamMaxes) => set(() => ({
        dataStreamMaxes: {
            ...datastreamMaxes,
        },
    })),
    setMins: (datastreamMins) => set(() => ({
        dataStreamMins: {
            ...datastreamMins,
        },
    })),
});
